export default __webpack_public_path__ + "static/media/ecommerce.50f7e286.png";